/* import __COLOCATED_TEMPLATE__ from './simple-percentage.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();